import { createAction } from 'redux-actions';
import * as actionTypes from './actionTypes';

export const substanceSelected = createAction(actionTypes.SUBSTANCE_SELECTED, SubstanceId => ({ SubstanceId }));
export const saveSubstanceProportionForm = createAction(actionTypes.SAVE_SUBSTANCE_PROPORTION_FORM, SubstanceId => ({
  SubstanceId,
}));
